export default class ConsigneeDetail {
    constructor() {

        this.id = 0;
        this.consigneeName = '';
        this.consigneeAddressLine1 = '';
        this.consigneeAddressLine2 = '';
        this.consigneeCity = '';
        this.consigneeCounty = '';
        this.consigneeCountry = '';
        this.consigneePostcode = '';
        this.consigneeVatNumber = '';
        this.consigneeContactId = 0;
        this.consigneeContactFullName = '';
        this.consigneeContactTitle = '';
        this.consigneeContactFirstName = '';
        this.consigneeContactLastName = '';
        this.consigneeContactPhone = '';
        this.consigneeContactEmail = '';
        this.consigneeContacts = [];
        this.consigneeRef = '';
        this.additionalRef = '';
    }
}
